import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getCurrentThreadsMe } from "../api/AppLinkApi";
import { ProfileSkeleton, ProfileDisplay, ConnectedStatus } from "./components";

const ThreadsSetting = ({ appInfo }) => {
  const { t } = useTranslation();

  const [connectedUser, setConnectedUser] = useState({
    picture: "",
    name: t("Anonymous"),
    description: "",
    id: "",
    username: "",
    threads_profile_picture_url: null,
    threads_biography: null,
    is_verified: false,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (appInfo.connected) {
      loadProfile();
    }
  }, [appInfo]); // eslint-disable-line react-hooks/exhaustive-deps

  const loadProfile = () => {
    setLoading(true);
    getCurrentThreadsMe()
      .then((data) => {
        setConnectedUser({
          picture: data?.threads_profile_picture_url,
          name: data?.name || t("Anonymous"),
          description: data?.username,
          id: data?.id,
          username: data?.username,
          threads_profile_picture_url: data?.threads_profile_picture_url,
          threads_biography: data?.threads_biography,
          is_verified: data?.is_verified,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <div className="grid grid-cols-12 gap-4 mb-4">
        <div className="col-span-12 lg:col-span-3">
          <div className={"w-40"}>{t("Threads Profile")}</div>
        </div>
        <div className="col-span-12 lg:col-span-7">
          {appInfo.connected ? (
            loading ? (
              <ProfileSkeleton />
            ) : (
              <ProfileDisplay
                picture={connectedUser.picture}
                name={connectedUser.name}
                username={connectedUser.username}
                biography={connectedUser.threads_biography}
                id={connectedUser.id}
                isVerified={connectedUser.is_verified}
              />
            )
          ) : (
            <div className="text-sm text-gray-500 py-2">
              {t("You need to connect your account first")}
            </div>
          )}
        </div>
        <div className="col-span-12 lg:col-span-2">{appInfo.connected && <ConnectedStatus />}</div>
      </div>
    </>
  );
};

export default ThreadsSetting;
